import {
  type ProcessedArticleBody,
  type ProcessedFullParagraph,
} from "@typings/Opensearch";

const EN_TIME = 200;

export default function getReadingTime(
  articleBody: ProcessedArticleBody,
): number {
  const paraWordCount = articleBody
    .filter((element): element is ProcessedFullParagraph => {
      return element.type === "paragraph";
    })
    .map((element) => {
      const length = element.value ? element.value.split(" ").length : 0;
      return length;
    });
  const wordCount = paraWordCount.reduce(
    (total, currentValue) => (total = total + currentValue),
    0,
  );

  const estimatedReadingTime = Math.max(1, Math.ceil(wordCount / EN_TIME));

  return estimatedReadingTime;
}
